export default __webpack_public_path__ + "static/twitter-56e51e249e78da83b8793cef6aca9da4.svg";